import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  scrollableContent: { maxHeight: theme.breakpoints.down('xs') ? 'calc(100vh - 320px)' : 'calc(100vh - 280px)', overflow: 'auto' },
}));
